module.exports = __webpack_public_path__ + "img/_ABS9786.6c91124e.jpg";